import { Empty } from "antd";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import cellEditFactory from "react-bootstrap-table2-editor";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone
} from "react-bootstrap-table2-paginator";
import { labels } from "../../../localization/labels";
import ContextMenu from "../../domain/page/ContextMenu";

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange
}) => (
  <Dropdown>
    <Dropdown.Toggle variant="secondary">{currSizePerPage}</Dropdown.Toggle>
    <Dropdown.Menu>
      {options.map(option => (
        <Dropdown.Item
          key={option.text}
          onClick={() => onSizePerPageChange(option.page)}
        >
          {option.text}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

const Table = props => {
  var sort = props.sort;

  const defaultSort = [
    {
      dataField: props.columns[0].dataField,
      order: props.columns[0].direction
        ? props.columns[0].direction
        : sort && sort.order
        ? sort.order
        : "asc"
    }
  ];

  if (!sort?.dataField || !sort?.order) sort = defaultSort[0];

  const pagination =
    props.paginationOptions !== undefined
      ? paginationFactory({
          ...props.paginationOptions,
          sizePerPageRenderer: sizePerPageRenderer,
          custom: true
        })
      : undefined;

  const rowEvents = {
    onClick: props.onRowClick ? props.onRowClick : function () {},
    onContextMenu: props.onContextMenu
  };

  const rowClasses = (row, rowIndex) => {
    if (props.onRowClick) {
      return "selectable";
    }
  };

  const buildTable = paginationTableProps => (
    <BootstrapTable
      ref={props.node}
      keyField={props.columns[0].dataField}
      data={props.data || []}
      columns={props.columns}
      rowEvents={rowEvents}
      selectRow={props.selectRow}
      filter={filterFactory()}
      cellEdit={cellEditFactory(props.cellEdit)}
      onTableChange={props.onTableChange}
      sort={{
        dataField: sort.dataField,
        order: sort.order
      }}
      noDataIndication={() =>
        props.data ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span>{labels.noData}</span>}
          />
        ) : null
      }
      bootstrap4
      hover
      condensed
      remote
      bordered={false}
      classes={"text-nowrap min-width-table"}
      wrapperClasses="table-responsive"
      rowClasses={rowClasses}
      {...(paginationTableProps ? paginationTableProps : [])}
    />
  );

  return (
    <div>
      {pagination ? (
        <PaginationProvider pagination={pagination}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <div>
                {buildTable(paginationTableProps)}
                <Row className="row-responsive">
                  <Col xs="12" sm="4" md="2" lg="1">
                    <SizePerPageDropdownStandalone {...paginationProps} />
                  </Col>
                  <Col xs="12" sm="6" md="8" lg="10">
                    <PaginationListStandalone {...paginationProps} />
                  </Col>
                </Row>
              </div>
            );
          }}
        </PaginationProvider>
      ) : (
        buildTable(undefined)
      )}

      <ContextMenu ref={props.customContextRef} />
    </div>
  );
};

Table.defaultProps = {
  paginationOptions: undefined
};

export default Table;
